import { createSignal, type Signal } from "solid-js"
import type { Nullable } from "../../typescript"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export type MouseDownEvent = MouseEvent & { dontSelect?: boolean }

export const useMouseDownEventSignal = createSharedCachedFactory((): Signal<Nullable<MouseDownEvent>> => {
  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Nullable<MouseDownEvent>>()

  return signal
})


